import { createAction, props } from '@ngrx/store';
import { CitationWithId } from '@sciflow/cite';
import type { ReferenceSortOrder } from './references.reducer';

export const uploadFile = createAction('[File] Uploading file');
/** Updates the list of references available in the project */
export const addReferences = createAction(
  '[ReferenceManagement] Add references',
  props<{ references: any[] }>(),
);
/** An in-text citation has been updated */
export const updateCitation = createAction(
  '[ReferenceManagement] Update citation in editor',
  props<{ citation: CitationWithId }>(),
);
export const syncCitationsFromDocument = createAction(
  '[ReferenceManagement] Sync citations from document',
  props<{ citations: CitationWithId[] }>(),
);

export const setActiveReferenceId = createAction(
  '[ReferenceManagement] Set active reference id',
  props<{ referenceId: string | null }>(),
);

export const setReferenceIdToEdit = createAction(
  '[ReferenceManagement] Set reference id to edit',
  props<{ referenceId: string }>(),
);

export const removeReference = createAction(
  '[ReferenceManagement] Remove reference',
  props<{ referenceId: string }>(),
);

export const clearReferenceIdToEdit = createAction(
  '[ReferenceManagement] Clear reference id to edit',
);

export const updateReferenceRawString = createAction(
  '[ReferenceManagement] Update reference raw string',
  props<{ key: string; rawCitationString?: string }>(),
);

export const syncReferenceRawCitation = createAction(
  '[ReferenceManagement] Sync reference raw citation',
  props<{ referenceId: string; rawCitation: string }>(),
);

export const setReferenceSortOrder = createAction(
  '[ReferenceManagement] Set reference sort order',
  props<{ sortOrder: ReferenceSortOrder }>(),
);
